import { render, staticRenderFns } from "./IceMap.vue?vue&type=template&id=10887109&"
import script from "./IceMap.vue?vue&type=script&lang=js&"
export * from "./IceMap.vue?vue&type=script&lang=js&"
import style0 from "./IceMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports